import React from "react"

import { Link } from "react-router-dom"

import { MainContainer } from "components/main-container"
import { H1, Paragraph } from "components/text"
import { Container } from "components/grid"

import { baseRoutes } from "routes"

export const NoMatchPage: React.FC = () => (
  <MainContainer
    mainContent={
      <Container py={8}>
        <H1 pb={4}>404</H1>
        <Paragraph>Ah, we couldn&apos;t find what you were looking for. </Paragraph>
        <Paragraph>
          <Link to={baseRoutes.homepage()}>Click here to go back to the homepage.</Link>
        </Paragraph>
      </Container>
    }
  />
)
